import { EventId } from '../../../../../commonv3/types/events';
import { action, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { EventShowView } from '../../../../types/events';
import { EventApis } from '../../../../apis/events';
import { UserEventReservationApis } from '../../../../../mainv2/api/user';
import { EventReservationApis } from '../../../../apis/eventReservations';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../../routes';
import { translateErrorMessage } from '../../../../../commonv3/api/protocol';

export class ReservationPaneState {
    @observable eventId: EventId = null;
    @observable event: RemoteResourceV3<EventShowView> = RemoteResourceV3.loading();
    @observable reservationError: string = null;
    @observable alreadyReserved: boolean = false;
    @observable submitting: boolean = false;

    async init(eventId: EventId) {
        this.eventId = eventId;
        this.reservationError = null;
        await this.reloadEvent();
        await this.reloadReservationStatus();
    }

    async reloadEvent() {
        await updateRemoteResourceV3(this.event, (v) => (this.event = v), () => EventApis.find(this.eventId));
    }

    async reloadReservationStatus() {
        const userReservations = await UserEventReservationApis.findAll();
        this.alreadyReserved =
            userReservations.find((r) => r.event_type === 'Event' && r.event_id === this.eventId) != null;
    }

    @action.bound
    async submit() {
        try {
            this.submitting = true;
            await EventReservationApis.create(this.eventId);
            GlobalStatesV3.routing.push(V3Routes.eventReservationComplete(this.eventId));
        } catch (e) {
            GlobalStatesV3.routing.push(V3Routes.eventReservationError(this.eventId, translateErrorMessage(e)));
        } finally {
            this.submitting = false;
        }
    }
}
